import { createSlice } from '@reduxjs/toolkit';

const initialQuestionState = {
  searchId: '',
  title: '',
  content_Id: '',
  customDescription: '',
  addInstruction: '',
  attempt: true,
};
const initialTheoryState = {
  theoryDescription: '',
  subHeading: ''
};
const initialVideoState = {
  videoURL: '',
  videoTitle: '',
  contentId: null,
  id: null,
  videoDescription: ''
}

const initialNotesData = {
  "authors": [],
  "conceptCode": [],
  "concepts": [],
  "completionPercent": 0,
  "favourites": ["5fecbbad06a1f142db764d32"],
  "pages": [],
  "status": "DRAFT",
  "subjects": [],
  "secondarySubjects": [],
  "pageState": {
    "page1": {
      question: { ...initialQuestionState },
      theory: { ...initialTheoryState },
      video: { ...initialVideoState },
      audio: { ...initialVideoState },
      pageContentType: 'Theory',
    }
  },
  "tags": [],
  "title": "",
  "attempt": {
    "page1": true
  },
  "subHeadingSettings": []
}

const notesSlice = createSlice({
  name: 'NotesData',
  initialState: {
    ...initialNotesData,
  },
  reducers: {
    handleNotesData: (state = {}, actionType = {}) => {

      return { ...state, ...actionType.payload };
    },
    resetNotesData: (state = {}, actionType) => {
      return { ...initialNotesData }
    }
  }
});

const { actions, reducer } = notesSlice;
export default reducer;
export const studyActions = actions;